

import qs from "qs";
import * as axiosHelper from "./api_helper";

const withTimezoneOffset = (params = {}) => ({
  ...params,
  tzOffset: params?.tzOffset ?? -new Date().getTimezoneOffset(),
});

export const getReports = async ({ payload }) => {
  const { reportType, ...params } = payload;
  const data = await axiosHelper.get(`/reports/${reportType}?${qs.stringify(withTimezoneOffset(params))}`);
  return data.result;
};

export const downloadReport = async (payload) => {
  const { reportType, ...params } = payload;
  return await axiosHelper.get(`/reports/download/${reportType}?${qs.stringify(withTimezoneOffset(params))}`, { responseType: "blob" });
};

export const getAffiliateReports = async ({ payload, clientId }) => {
  const data = await axiosHelper.get(`/affiliate/${clientId}?${qs.stringify(payload)}`);
  return data.result;
};

export const getSymbols = async (params = {}) => {
  const query = qs.stringify(params || {});
  const url = query ? `/reports/symbols?${query}` : "/reports/symbols";
  const data = await axiosHelper.get(url);
  return data.result;
};
